function main() {

    var $ = jQuery;
    var self = this;

    jQuery.fn.exists = function () {
        return this.length > 0;
    };

    jQuery.fn.hasAttr = function (name) {
        var attr = this.attr(name);
        return typeof attr !== 'undefined' && attr !== false;
    };


    this.init = function () {
        console.log("functions working");
        self.navFunctions();
    };

    self.navFunctions = function(){

        // Sticky Nav

        window.onscroll = function() {
            scrollFunction();
        };

        function scrollFunction() {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                $(".home-logo").addClass("scrolled");
            } else {
                $(".home-logo").removeClass("scrolled");
            }
        }

        // Hamburger Interaction

        $(".hamburger").on("click", function(){
            if($(".hamburger.is-active").exists()){
                $(this).removeClass("is-active");
            }else{
                $(this).addClass("is-active");
            }

            if($(".responsive-menu.is-shown").exists()){
                    $(".responsive-menu").removeClass("is-shown");
            }else{
                $(".responsive-menu").addClass("is-shown");
            }

            $("li.menu-item").each(function(i){
                var li = $(this);
                setTimeout(function() {
                    li.toggleClass('is-shown');
                }, 50 * i);
            });
        });

        // Dates Link Scroll Animation

        $(document).on('click', '.scroll-link', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top -150
            }, 500);
        });

    }


}

var $main = new main();

jQuery(function () {
    $main.init();
});


